<template>
  <div class="kt-login__logo">
    <a href="/">
      <img src="img/ttc-logo.png" width="110">
    </a>
  </div>
</template>

<script>
export default {
  name: 'FormLogo'
}
</script>
